"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _olapicDataContext = require("./olapicDataContext");
Object.keys(_olapicDataContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _olapicDataContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _olapicDataContext[key];
    }
  });
});
var _useOlapicDetails = require("./useOlapicDetails");
Object.keys(_useOlapicDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useOlapicDetails[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useOlapicDetails[key];
    }
  });
});
